import { Dialog } from '@design-system/dialog';
import {
  getLocalStorageData,
  removeLocalStorageData,
} from '@phx-husky/local-storage';
import { navigate } from 'gatsby';
import React, { FC, useContext } from 'react';

import { ExternalLinkDialogContext } from '~/context/ExternalLinkDialogContext';
import { modalExternalMapper } from '~/mappers/modalExternal';
import { gtmService } from '~/services/gtm';
import { GTM_LOCALSTORAGE_DATA } from '~/utils/constants';

export const ExternalLinkDialog: FC = () => {
  const { close, isVisible, redirectUrl, modalExternal, isModalExternal } =
    useContext(ExternalLinkDialogContext);
  const lastRetailer = getLocalStorageData(
    GTM_LOCALSTORAGE_DATA.lastRetailerTitle
  );

  return isModalExternal && modalExternal ? (
    <Dialog
      {...modalExternalMapper(modalExternal)}
      isShowing={isVisible}
      close={close}
      closeModal={close}
      onPrimaryButtonClick={() => {
        if (lastRetailer) {
          gtmService.emitRetailerLinkConfirmation(lastRetailer, redirectUrl);
          removeLocalStorageData(GTM_LOCALSTORAGE_DATA.lastRetailerTitle);
        }
        navigate(redirectUrl);
      }}
    />
  ) : null;
};

export default ExternalLinkDialog;
